import { faClock, faUsers } from '@fortawesome/pro-regular-svg-icons';
import _orderBy from 'lodash.orderby';

import { useLayout } from 'lib/common/contexts/layout/LayoutContext';

import Icon from 'lib/common/components/Icon';
import Text from 'lib/common/components/Text';

import AgentIcon from './components/AgentIcon';
import Queue from './components/Queue';
import SoftphoneQueue from './components/SoftphoneQueue';

import styles from './queues.module.scss';

const Queues = ({ queues }) => {
  const { isSoftphone } = useLayout();

  const QueueComponent = isSoftphone ? SoftphoneQueue : Queue;

  return (
    <div className={styles['queues']}>
      {!isSoftphone && (
        <div className={styles['queues__header']}>
          <Text type="heading3">Queue</Text>
          <div className={styles['queues__header__icons']}>
            <Icon className={styles['queues__header__icons__icon']} icon={faUsers} tooltip="Contacts in queue" />
            <Icon className={styles['queues__header__icons__icon']} icon={faClock} tooltip="Oldest contact in queue" />
            <AgentIcon />
          </div>
        </div>
      )}
      {_orderBy(queues, 'name').map((queue) => (
        <QueueComponent key={queue.Id} {...queue} />
      ))}
    </div>
  );
};

export default Queues;
